<div class="container-fluid filter-selections">
  <div class="row">
    <div class="col">
      <app-validation-summary></app-validation-summary>
      <h3 class="selected-filters-header group-label">{{getSelectedFilterHeader()}}</h3>
      <hr />
      <app-data-sets></app-data-sets>
      <hr />
      <div id="filterSelectionsSummary">
        <div *ngFor="let indicationGroup of allIndications">
          <h4 class="group-label">{{indicationGroup.displayName}} {{indicationGroupSelectionsCount(indicationGroup)}}</h4>
          <div *ngIf="groupHasIndicationSelections(indicationGroup); else noSelections">
            <ul class="indication-selection-section" style="list-style-type: none;" *ngFor="let indication of indicationGroup.indications;">
              <li class="indication-selection-name" *ngIf="indication.selected">{{indication.displayName}}</li>
              <ul class="indication-selection-details" *ngIf="indication.selected">
                <li *ngIf="indication.diagnosedOnly" style="font-style: italic;">Diagnosed Only</li>
                <div *ngIf="indication.name === 'dyslipidemia'">
                  <div id="dyslipidemiaFilters"></div>
                  {{displayDislipidemia(indication.selections)}}
                </div>
                <div *ngIf="indication.name === 'insomnia'">
                  <div id="insomniaFilters"></div>
                  {{displayInsomnia(indication.selections)}}
                </div>
                <div *ngIf="indication.name === 'hepatitis'">
                  <div id="hepatitisFilters"></div>
                  {{displayHepatitis(indication.selections)}}
                </div>
                <div *ngIf="!['dyslipidemia', 'insomnia', 'hepatitis'].includes(indication.name)">
                  <li *ngFor="let selection of indication.selections">{{displayInputSelection(selection, indication.selections)}}</li>
                </div>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noSelections>
  <p class="no-selections">No selections</p>
</ng-template>
